var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack6Solid41({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.59,5.85a2.28,2.28,0,0,1,.46-1.57,1.62,1.62,0,0,1,1.26-.51,1.66,1.66,0,0,1,1.29.51,2.27,2.27,0,0,1,.46,1.57A2.27,2.27,0,0,1,6.6,7.42a1.62,1.62,0,0,1-1.26.51,1.66,1.66,0,0,1-1.29-.51A2.25,2.25,0,0,1,3.59,5.85Zm1.17,0a2,2,0,0,0,.18,1,.43.43,0,0,0,.37.2.44.44,0,0,0,.38-.2,2.14,2.14,0,0,0,.17-1,2.09,2.09,0,0,0-.17-1,.46.46,0,0,0-.75,0A2,2,0,0,0,4.76,5.84Zm1.7,6.24H5.34l4.2-8.31h1.08ZM8.9,10a2.27,2.27,0,0,1,.46-1.57,1.64,1.64,0,0,1,1.27-.51,1.64,1.64,0,0,1,1.28.51A2.27,2.27,0,0,1,12.38,10a2.28,2.28,0,0,1-.47,1.57,1.62,1.62,0,0,1-1.26.51,1.66,1.66,0,0,1-1.29-.51A2.28,2.28,0,0,1,8.9,10Zm1.18,0a2.16,2.16,0,0,0,.17,1,.43.43,0,0,0,.37.19A.4.4,0,0,0,11,11a2,2,0,0,0,.18-1A2.14,2.14,0,0,0,11,9a.42.42,0,0,0-.38-.19.42.42,0,0,0-.37.19A2.14,2.14,0,0,0,10.08,10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack6Solid41);
export default __webpack_public_path__ + "static/media/Symbolpack_6_solid_41.9cf481a02fe1b257f9edbe138c2510b4.svg";
export { ForwardRef as ReactComponent };